import { IconButton } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import InputAdornment from "@material-ui/core/InputAdornment";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from "@material-ui/icons";
import React, { useState } from "react";
import strings from "../_constants/strings";
import TBTooltip from "./TBTooltip";

const useStyles = theme => ({
  input: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0
    }
  },
  paper: {
    display: "flex",
    width: "50vw",
    height: "50vh"
  },
  formtitle: {
    width: "50%",
    fontSize: "28px",
    padding: "5%"
  },
  loginbutton: {
    MaxWidth: "max-content",
    backgroundColor: "#F54040",
    color: "white",
    marginBottom: "7%"
  },
  input1paper: {
    display: "flex",
    alignItems: "center",
    height: "35px",
    width: "100%",
    marginBottom: "15px",
    padding: "5px",
    paddingLeft: "5%",
    boxShadow: 'none',
    border: '1px solid #7F86A6',
    borderRadius: 0,
  },
  divider: {
    height: 28,
    margin: "4px"
  },
  errorMsg: {
    color: "red"
  }
});

function InputPaper(props) {
  const {
    LABELS: { NEW_PASSWORD },
  } = strings;

  const [showPass, setShowPass] = useState(false);

  const {
    autoFocus,
    classes,
    name,
    placeholder,
    value,
    image,
    alt_text,
    handler,
    inputtype,
    disabled,
    error,
    errorMsg,
    errorPos
  } = props;

  let isPass = inputtype == 'password';
  let isNewPass = placeholder == NEW_PASSWORD;
  let isPin = inputtype == 'confirmpin';

  return (
    <>
      <TBTooltip
        placement={errorPos}
        open={!!errorMsg}
        title={errorMsg}
        {...props}>
        <Paper component="div" className={classes.input1paper}>
          <InputBase
            autoFocus={autoFocus}
            inputProps={{ className: classes.input }}
            type={showPass ? 'text' : isPin ? "number" : inputtype}
            value={value}
            name={name}
            autoComplete="off"
            onChange={handler}
            placeholder={placeholder}
            disabled={disabled}
            error={error}
            endAdornment={
              <InputAdornment position="end" style={{height:24, width:24}}>
                {image && (
                  <Divider className={classes.divider} orientation="vertical" />
                )}
                {!isPass &&
                  <img src={image} alt={alt_text} width='20vh'></img>
                }
                {isPass &&
                  <IconButton
                    tabIndex={-1}
                    style={{ padding: 0 }}
                    aria-label="toggle password visibility"
                    onClick={() => setShowPass(!showPass)}
                  >
                    {showPass ?
                      <VisibilityOffIcon style={{ opacity: "0.6" }} />
                      : <VisibilityIcon />}
                  </IconButton>}
              </InputAdornment>
            }
          />
        </Paper>
      </TBTooltip>
    </>
  );
}
export default withStyles(useStyles)(InputPaper);
